import { useEffect, useRef, useState } from 'react';

export default function VideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el) => el.classList.add('animate-in'));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="relative w-full max-w-5xl mx-auto">
          <div className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out relative aspect-video rounded-lg overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20house%20entrance%20with%20elegant%20brass%20house%20number%20plate%20installation%20process%2C%20craftsman%20working%20on%20premium%20signage%2C%20workshop%20environment%20with%20tools%20and%20materials%2C%20warm%20industrial%20lighting%20with%20dramatic%20shadows%20and%20professional%20photography%20style%2C%20wide%20angle%20video%20thumbnail&width=1280&height=720&seq=video-thumb-2026&orientation=landscape"
              alt="Proces proizvodnje kućnih brojeva"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/20" />
            <button
              onClick={() => setIsPlaying(true)}
              className="absolute inset-0 flex items-center justify-center group cursor-pointer"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-white/90 rounded-full group-hover:scale-110 transition-transform duration-300">
                <div className="w-6 h-6 flex items-center justify-center text-foreground-950 ml-1">
                  <i className="ri-play-fill text-2xl" />
                </div>
              </div>
            </button>
          </div>

          {isPlaying && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
              <div className="relative w-full max-w-4xl aspect-video bg-background-100 rounded-lg overflow-hidden">
                <button
                  onClick={() => setIsPlaying(false)}
                  className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-white rounded-full text-foreground-700 hover:text-foreground-950 transition-colors"
                >
                  <i className="ri-close-line text-xl" />
                </button>
                <div className="w-full h-full flex items-center justify-center text-foreground-700">
                  <div className="text-center">
                    <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 text-amber-600">
                      <i className="ri-video-line text-4xl" />
                    </div>
                    <p className="text-sm font-label">Video plejer</p>
                    <p className="text-xs text-foreground-600 mt-1">Video proizvodnje uskoro</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}